var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('car-rental-hero'),_c('car-rental-categories'),_c('car-rental-highlights'),_c('ForavilaGuarantee')],1)}
var staticRenderFns = []

export { render, staticRenderFns }